import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    item: 'heading-lg flex min-h-[50px] flex-1 items-center justify-between px-6 md:px-4',
    itemLabel: 'flex items-center gap-2.5',
    itemCircle: 'size-3 rounded-full',
    diamondIcon: 'size-6',
    itemCircleWrapper: 'flex size-6 min-w-6 items-center justify-center'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
